import React from 'react';
import { withStyles } from '@mui/styles';
import styled from 'styled-components';
import { Tooltip } from '@mui/material';
import {
  ThumbUp as ThumbUpI,
  Help as HelpI,
  ThumbDown as ThumbDownI,
  TrendingDown as TrendingDownI,
  KeyboardArrowDown as KeyboardArrowDownI,
  Remove as RemoveI,
  KeyboardArrowUp as KeyboardArrowUpI,
  TrendingUp as TrendingUpI
} from '@mui/icons-material';

const NUMBER_COLORS = {
  1: '#c00',
  2: '#ffbd33',
  3: '#cc0',
  4: '#32da50',
  5: '#0a0',
};

const ICONS_3_COLOR = {
  1: '#c00',
  2: '#cc0',
  3: '#0a0',
};

const ICONS_5_COLOR = {
  1: '#c00',
  2: '#ffbd33',
  3: '#cc0',
  4: '#32da50',
  5: '#0a0',
};

const TYPES = {
  icons_3: 'icons_3',
  icons_5: 'icons_5',
  numbers_5: 'numbers_5',
};

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

export const IrRate = ({
  children,
  displayType,
  onClick,
  values
}) => {
  //options.value = {label: "1", value: "1", criteria: "Lousy"}

  const iconStyle = {transform: 'translateY(2px)'};
  const iconStyleTdown = {transform: 'translateY(2px) scaleX(-1)'};

  const getIcon3 = (value) => {
    switch(value) {
      case '1':
        return <ThumbUpI style={iconStyle}/>;
      case '2':
        return <HelpI style={iconStyle}/>;
      default:
        return <ThumbDownI style={iconStyle}/>;
    }
  };

  const getIcon5 = (value) => {
    switch(value) {
      case '1':
        return <TrendingDownI style={iconStyleTdown}/>;
      case '2':
        return <KeyboardArrowDownI style={iconStyle}/>;
      case '3':
        return <RemoveI style={iconStyle}/>;
      case '4':
        return <KeyboardArrowUpI style={iconStyle}/>;
      default:
        return <TrendingUpI style={iconStyle}/>;
    }
  }; 

  const pickerNumber = 
    <React.Fragment>
      <OptContainer>
        {(values||[]).map((v, i) => (
          <Opt value={parseInt(v.value)} onClick={() => onClick(v.value)} criteria={v.criteria||v.label} isLast={(i === values.length -1)}/>
        ))}
      </OptContainer>
    </React.Fragment>;

    const pickerIcon3 = 
      <React.Fragment>
        <OptContainer>
          {(values||[]).map((v, i) => (
            <OptI3
              value={parseInt(v.value)}
              onClick={() => onClick(v.value)}
              criteria={v.criteria||v.label}
              isLast={(i === values.length -1)}
            >{getIcon3(v.value)}</OptI3>
          ))}
        </OptContainer>
      </React.Fragment>;

    const pickerIcon5 = 
      <React.Fragment>
        <OptContainer>
          {(values||[]).map((v, i) => (
            <OptI5
              value={parseInt(v.value)}
              onClick={() => onClick(v.value)}
              criteria={v.criteria||v.label}
              isLast={(i === values.length -1)}
            >{getIcon5(v.value)}</OptI5>
          ))}
        </OptContainer>
      </React.Fragment>;

  const picker = (displayType === TYPES.icons_3) ? pickerIcon3 : (displayType === TYPES.icons_5) ? pickerIcon5 : pickerNumber;

  return (
    <LightTooltip title={picker} placement="bottom" interactive>
      {children}
    </LightTooltip>
  );
};

const OptContainer = styled.div`
  width: auto;
  height: 30px;
`;

const Opt = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 30px;
  height: 30px;
  background-color: ${props => NUMBER_COLORS[props.value]};
  border-radius: 15px;
  color: white;
  display: inline-block;
  margin-right: ${props => props.isLast ? 0 : 3}px;
  &:after {
    position: absolute;
    content: "${props => props.value}";
    text-align: center;
    width: 100%;
    font-size: 1em;
    left: 50%;
    transform: translate(-50%, 8px);
  }
  &:hover {
    &:before {
      position: absolute;
      background-color: #5f5f5f;
      content: "${props => props.criteria}";
      display: inline-block;
      font-size: 1em;
      left: 50%;
      transform: translate(-50%, 38px);
      width: max-content;
      padding: 3px;
      border-radius: 5px;
    }
  }
`;

const OptI3 = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 30px;
  height: 30px;
  background-color: ${props => ICONS_3_COLOR[props.value]};
  border-radius: 15px;
  color: white;
  display: inline-block;
  margin-right: ${props => props.isLast ? 0 : 3}px;
  text-align: center;
  paddding-top: 20px;
  &:hover {
    &:before {
      position: absolute;
      background-color: #5f5f5f;
      content: "${props => props.criteria}";
      display: inline-block;
      font-size: 1em;
      left: 50%;
      transform: translate(-50%, 38px);
      width: max-content;
      padding: 3px;
      border-radius: 5px;
    }
  }
`;

const OptI5 = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 30px;
  height: 30px;
  background-color: ${props => ICONS_5_COLOR[props.value]};
  border-radius: 15px;
  color: white;
  display: inline-block;
  margin-right: ${props => props.isLast ? 0 : 3}px;
  text-align: center;
  paddding-top: 20px;
  &:hover {
    &:before {
      position: absolute;
      background-color: #5f5f5f;
      content: "${props => props.criteria}";
      display: inline-block;
      font-size: 1em;
      left: 50%;
      transform: translate(-50%, 38px);
      width: max-content;
      padding: 3px;
      border-radius: 5px;
    }
  }
`;